import { APP } from '@/app.config'
import { ToastProvider } from '@/components/ui'
import { router } from '@/routes'
import { useConsoleStore } from '@/store/consoleStore'
import { useEffect } from 'react'
import { RouterProvider } from 'react-router/dom'

export default function App() {
  const status = useConsoleStore((s) => s.status)
  const boot = useConsoleStore((s) => s.boot)
  useEffect(() => {
    void boot()
  }, [boot])
  if (status === 'loading') {
    return (
      <div className="boot">
        <span className="t-title">{APP.name}</span>
      </div>
    )
  }
  return (
    <ToastProvider>
      <RouterProvider router={router} />
    </ToastProvider>
  )
}
